//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "SiftDate",
  props: ["sift", "col", "label-width"],
  components: {},
  data: function data() {
    var _this = this;

    return {
      value: null,
      option: {
        disabledDate: function disabledDate(time) {
          if (_this.sift.min && time < _this.sift.min || _this.sift.max && time > _this.sift.max) {
            return true;
          }

          return false;
        }
      }
    };
  },
  computed: {},
  created: function created() {
    this.sift.defaultValue ? this.value = this.sift.defaultValue : null;
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setValue: function setValue(value) {
      this.value = value;
    },
    getValue: function getValue() {
      return this.value;
    },
    resetValue: function resetValue() {
      this.value = this.sift.defaultValue ? this.sift.defaultValue : "";
    },
    changeValue: function changeValue() {
      this.$emit("change");
    }
  },
  watch: {},
  filters: {}
};